export default __webpack_public_path__ + "static/media/KevserTanrikulu.8aa44abc.webp";